import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';
import { MarketStatus } from 'communication/types/openSubmissions/OpenSubmissionsResponseData';
import { VenueType } from 'utils/venueTypeUtils';

export type OpenSubmissionsStreamState =
    WidgetStreamState<OpenSubmissionsDataState>;

export interface OpenSubmissionsDataState {
    submissions: OpenSubmissionsStreamItem[];
}

export interface OpenSubmissionsStreamItem {
    _i: number;
    id: number;
    parentOrderId: number;
    limitPrice: number;
    averageExecutionPrice: number;
    isIOI: boolean;
    executedQuantity: number;
    executionVenueName: string;
    orderQty: number;
    remainingQty: number;
    status: string;
    updateTimeEpoch: number;
    marketStatus: MarketStatus;
    isFading?: boolean;
    shouldRemove?: boolean;
    executionVenueType: VenueType;
    executionVenueCode: string;
    actor: string;
    pegType: string | number;
}

export const initialOpenSubmissionsDataState: OpenSubmissionsDataState = {
    submissions: [],
};

export const initialOpenSubmissionsStreamState: OpenSubmissionsStreamState = {
    data: initialOpenSubmissionsDataState,
    messages: [],
};

export const isChildOrder = (item: OpenSubmissionsStreamItem) =>
    item.id !== item.parentOrderId;

export const isFilled = (item: OpenSubmissionsStreamItem) =>
    item.status === 'Filled';

export const isFading = (item: OpenSubmissionsStreamItem) => !!item.isFading;

export const isCancelledOrRejected = (item: OpenSubmissionsStreamItem) =>
    item.status === 'Cancelled' || item.status === 'Rejected';

export const isNotCancelledOrRejected = (item: OpenSubmissionsStreamItem) =>
    !isCancelledOrRejected(item);
